function xorOperation(p1, p2) {
    return p1 ^ p2;
}

function PDF47CRReader(dataFromId) {
    const key = [0x27, 0x30, 0x04, 0xA0, 0x00, 0x0F, 0x93, 0x12, 0xA0, 0xD1, 0x33, 0xE0, 0x03, 0xD0, 0x00, 0xDf, 0x00];
    const keyBytes = key;
    const dataFromIdBytes = dataFromId; 

    let index = 0;
    let data = "";
    const alphanumericRegex = /^[a-zA-Z0-9ÁÉÍÓÚáéíóúÑñ]$/;

    for (const byteFromArray of dataFromIdBytes) {
        if (index === 17) {
            index = 0;
        }

        const caracter = xorOperation(keyBytes[index], byteFromArray);
        const char_caracter = String.fromCharCode(caracter);

        if (alphanumericRegex.test(char_caracter)) {
            data += char_caracter;
        } else {
            data += " ";
        }
        index++;
    }

    const identification = data.substring(0, 9).trim();
    const last_name = data.substring(9, 35).trim();
    const last_name_two = data.substring(35, 61).trim();
    const first_name = data.substring(61, 91).trim();

    return { identification, first_name, last_name, last_name_two };
}

export default PDF47CRReader;
